module.exports = __webpack_public_path__ + "img/Frame 6796_1@2x.57dbb63d.png";